import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { useTheme } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAuth } from '../context/AuthContext';
import { getGreeting } from '../utils/greeting';

const DashboardHeader: React.FC = () => {
  const theme = useTheme();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.log('Sign out error:', error);
    }
  };

  const firstName = user?.displayName?.split(' ')[0] ?? 'there';

  return (
    <View style={styles.header}>
      <View>
        <Text style={[styles.title, { color: theme.colors.onSurface }]}>
          {getGreeting()}, {firstName}
        </Text>
        <Text style={[styles.subtitle, { color: theme.colors.onSurfaceVariant }]}>
          Track your fleet finances
        </Text>
      </View>
      <TouchableOpacity
        style={[styles.profileButton, { backgroundColor: theme.colors.primary }]}
        onPress={handleSignOut}
      >
        {user?.photoURL ? (
          <Image source={{ uri: user.photoURL }} style={styles.avatar} />
        ) : (
          <MaterialCommunityIcons
            name="account-circle"
            size={20}
            color={theme.colors.onPrimary}
            testID="profile-button"
          />
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: 'transparent',
  },
  title: {
    fontFamily: 'Manrope-SemiBold',
    fontSize: 22,
  },
  subtitle: {
    fontFamily: 'Inter-Regular',
    fontSize: 14,
    marginTop: 2,
  },
  profileButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    shadowColor: '#111c2d',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 2,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
  },
});

export default DashboardHeader;
